import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './app/App';
import { loadExerciseOverrides } from './app/exerciseOverrides';
import './styles/global.css';
import './app/App.css';

// Not awaited: the app must paint offline. Scoring awaits it separately.
void loadExerciseOverrides();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
